import { render, staticRenderFns } from "./office-information.vue?vue&type=template&id=54c3b15e"
import script from "./office-information.vue?vue&type=script&lang=js"
export * from "./office-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports